import styled, { css } from 'styled-components';

const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;

    ${({ $useChartToolbar, $chartToolbar }) =>
        ($useChartToolbar || $chartToolbar) &&
        css`
            height: 32px;

            & > button {
                height: 32px;
                box-sizing: border-box;
                align-self: center;
            }
        `}
`;

export default ButtonGroup;